<script lang="ts">
  // The floating ace-monster hero: Cyber End Dragon (official transparent
  // render) with a breathing aura, slow float, and a specular sheen masked by
  // the art's own alpha. Shared by Title and ModeSelect so the two screens
  // can't drift apart. `accent` regrades the glow — cool blue at rest, magenta
  // when Free Duel is hot — so the hero reacts to the player's choice.
  import cyberend from "../../assets/cyberend.webp";

  let { accent = "blue" }: { accent?: "blue" | "magenta" } = $props();
</script>

<div
  class="hero pointer-events-none absolute right-[-8%] top-1/2 aspect-[1470/779] w-[min(64vw,1180px)] -translate-y-1/2 select-none max-lg:right-[-32%] max-lg:opacity-40 {accent ===
  'magenta'
    ? 'hot'
    : ''}"
  aria-hidden="true"
>
  <div class="aura aura-blue absolute inset-[-10%]"></div>
  <div class="aura aura-magenta absolute inset-[-10%]"></div>
  <img src={cyberend} alt="" class="dragon relative size-full object-contain" draggable="false" />
  <div class="sheen absolute inset-0"></div>
</div>

<style>
  /* Accent regrade: the drop-shadow pair rides CSS vars, so flipping the vars
     transitions the whole glow; the two auras crossfade. */
  .hero {
    --g1: rgba(130, 180, 255, 0.28);
    --g2: rgba(80, 130, 255, 0.15);
  }
  .hero.hot {
    --g1: rgba(255, 105, 175, 0.3);
    --g2: rgba(255, 45, 126, 0.16);
  }
  .dragon {
    filter: drop-shadow(0 0 30px var(--g1)) drop-shadow(0 0 100px var(--g2));
    transition: filter 0.6s var(--ease-out-quint);
    animation: dragon-float 12s ease-in-out infinite;
  }
  .aura {
    animation: aura-pulse 7s ease-in-out infinite;
    transition: opacity 0.6s var(--ease-out-quint);
  }
  .aura-blue {
    background: radial-gradient(48% 42% at 52% 52%, rgba(140, 180, 255, 0.15), rgba(120, 140, 255, 0.045) 55%, transparent 72%);
  }
  .aura-magenta {
    background: radial-gradient(48% 42% at 52% 52%, rgba(255, 120, 180, 0.16), rgba(255, 60, 140, 0.05) 55%, transparent 72%);
    opacity: 0;
  }
  .hero.hot .aura-blue {
    opacity: 0;
  }
  .hero.hot .aura-magenta {
    opacity: 1;
  }
  /* Specular band masked by the art's alpha, so light sweeps the body only. */
  .sheen {
    -webkit-mask-image: url("../../assets/cyberend.webp");
    mask-image: url("../../assets/cyberend.webp");
    -webkit-mask-size: contain;
    mask-size: contain;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-position: center;
    background: linear-gradient(100deg, transparent 30%, rgba(210, 235, 255, 0.28) 50%, transparent 70%);
    background-size: 300% 100%;
    animation: sheen-sweep 9s ease-in-out infinite;
    mix-blend-mode: screen;
  }
  @keyframes dragon-float {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-18px);
    }
  }
  @keyframes aura-pulse {
    0%,
    100% {
      opacity: 0.7;
      transform: scale(1);
    }
    50% {
      opacity: 1;
      transform: scale(1.05);
    }
  }
  /* The magenta aura's pulse must not fight its crossfade: when hidden it stays hidden. */
  .hero:not(.hot) .aura-magenta,
  .hero.hot .aura-blue {
    animation: none;
  }
  @keyframes sheen-sweep {
    0%,
    55% {
      background-position: 120% 0;
    }
    85%,
    100% {
      background-position: -60% 0;
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .dragon,
    .aura {
      animation: none;
    }
    .sheen {
      display: none;
    }
  }
</style>
